import React, { useState } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, StarIcon, ShoppingCartIcon } from 'lucide-react';
const CHECKOUT_URL_BASICO = 'https://checkout.descargatop.com/cart/40955457798193:1';
const CHECKOUT_URL_COMPLETO = 'https://checkout.descargatop.com/cart/40955457896497:1';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState<'completo' | 'basico'>('completo');
  const checkoutUrl = selectedPlan === 'completo' ? CHECKOUT_URL_COMPLETO : CHECKOUT_URL_BASICO;
  return <section id="compra" className="bg-white py-16 md:py-20 px-4" data-id="element-206">
      <div className="max-w-3xl mx-auto" data-id="element-207">
        <div className="bg-gradient-to-b from-gray-900 to-gray-800 rounded-2xl p-6 md:p-10 shadow-2xl border border-amber-500/30" data-id="element-208">
          {/* Header */}
          <div className="text-center mb-8" data-id="element-209">
            <ShoppingCartIcon className="w-10 h-10 text-amber-400 mx-auto mb-3" data-id="element-210" />
            <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-white leading-tight" data-id="element-211">
              ELEGÍ TU PLAN
              <br data-id="element-212" />Y EMPEZÁ HOY
            </h2>
            <p className="text-gray-400 mt-3 text-base" data-id="element-213">
              Descarga inmediata. Acceso de por vida.
            </p>
            <p className="text-amber-400 font-semibold mt-2 text-sm" data-id="element-214">
              👇 Elegí tu plan y dale a COMPRAR AHORA
            </p>
            <p className="text-green-400 font-semibold mt-1 text-sm" data-id="element-215">
              💳 Pagalo en tu moneda local
            </p>
          </div>

          {/* Plan Cards */}
          <div className="space-y-4 mb-8" data-id="element-216">
            {/* PACK BÁSICO */}
            <div onClick={() => setSelectedPlan('basico')} className={`w-full text-left rounded-xl p-4 md:p-5 border-2 transition-all duration-300 cursor-pointer ${selectedPlan === 'basico' ? 'border-amber-400 bg-gray-800' : 'border-gray-600 bg-gray-800/50 opacity-70 hover:opacity-90'}`} data-id="element-217">
              <div className="flex items-center justify-between" data-id="element-218">
                <div className="flex items-center gap-3" data-id="element-219">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'basico' ? 'border-amber-400 bg-amber-400' : 'border-gray-500'}`} data-id="element-220">
                    {selectedPlan === 'basico' && <div className="w-2 h-2 bg-gray-900 rounded-full" data-id="element-221" />}
                  </div>
                  <div data-id="element-222">
                    <p className="font-heading font-bold text-white text-lg" data-id="element-223">
                      PACK BÁSICO
                    </p>
                    <p className="text-gray-400 text-sm" data-id="element-224">
                      +1000 planos + bonos
                    </p>
                  </div>
                </div>
                <div className="text-right" data-id="element-225">
                  <p className="text-gray-500 line-through text-sm" data-id="element-226">
                    USD $29.99
                  </p>
                  <p className="font-heading font-extrabold text-white text-2xl md:text-3xl" data-id="element-227">
                    USD $12.99
                  </p>
                </div>
              </div>

              {/* Detalle Pack Básico — solo visible cuando está seleccionado */}
              <div className={`overflow-hidden transition-all duration-300 ${selectedPlan === 'basico' ? 'max-h-[500px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-228">
                <div className="border-t border-gray-700 pt-3 ml-8 space-y-2" data-id="element-229">
                  <div className="flex items-center gap-2" data-id="element-230">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-231" />
                    <span className="text-gray-200 text-sm" data-id="element-232">
                      +1000 planos industriales
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-233">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-234" />
                    <span className="text-gray-200 text-sm" data-id="element-235">
                      Herrería Artística
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-236">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-237" />
                    <span className="text-gray-200 text-sm" data-id="element-238">
                      Carpintería que Vende
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-239">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-240" />
                    <span className="text-gray-200 text-sm" data-id="element-241">
                      Tornería desde Cero
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-242">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-243" />
                    <span className="text-gray-200 text-sm" data-id="element-244">
                      Presupuesto + Ventas
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-245">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-246" />
                    <span className="text-gray-200 text-sm" data-id="element-247">
                      Soldadura desde Cero
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-248">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-249" />
                    <span className="text-gray-200 text-sm" data-id="element-250">
                      Planos Premium
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-251">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-252" />
                    <span className="text-gray-200 text-sm" data-id="element-253">
                      Acceso inmediato
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-254">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-255" />
                    <span className="text-gray-200 text-sm" data-id="element-256">
                      Descarga digital
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-257">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-258" />
                    <span className="text-gray-200 text-sm" data-id="element-259">
                      Acceso de por vida
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* PACK COMPLETO */}
            <div onClick={() => setSelectedPlan('completo')} className={`w-full text-left rounded-xl p-4 md:p-5 border-2 transition-all duration-300 cursor-pointer relative ${selectedPlan === 'completo' ? 'border-amber-400 bg-gray-800 ring-1 ring-amber-400/50' : 'border-gray-600 bg-gray-800/50 opacity-70 hover:opacity-90'}`} data-id="element-260">
              <div className="flex items-center justify-between" data-id="element-261">
                <div className="flex items-center gap-3" data-id="element-262">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'completo' ? 'border-amber-400 bg-amber-400' : 'border-gray-500'}`} data-id="element-263">
                    {selectedPlan === 'completo' && <div className="w-2 h-2 bg-gray-900 rounded-full" data-id="element-264" />}
                  </div>
                  <div data-id="element-265">
                    <div className="flex items-center gap-2 flex-wrap" data-id="element-266">
                      <span className="text-xl" data-id="element-267">🏆</span>
                      <p className="font-heading font-bold text-white text-lg" data-id="element-268">
                        PACK COMPLETO
                      </p>
                    </div>
                    <div className="flex items-center gap-2 flex-wrap mt-1" data-id="element-269">
                      <span className="bg-green-500 text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-270">
                        MÁS ELEGIDO
                      </span>
                      <span className="bg-amber-500 text-black text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-271">
                        MEJOR VALOR
                      </span>
                    </div>
                  </div>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-272">
                  <p className="text-gray-500 line-through text-sm" data-id="element-273">
                    USD $39.99
                  </p>
                  <p className="font-heading font-extrabold text-amber-400 text-2xl md:text-3xl" data-id="element-274">
                    USD $15.99
                  </p>
                </div>
              </div>

              {/* Detalle Pack Completo — solo visible cuando está seleccionado */}
              <div className={`overflow-hidden transition-all duration-300 ${selectedPlan === 'completo' ? 'max-h-[600px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-275">
                <div className="border-t border-gray-700 pt-3 ml-8 space-y-2" data-id="element-276">
                  <p className="text-gray-300 text-sm font-semibold mb-2" data-id="element-277">
                    Todo lo del Pack Básico:
                  </p>
                  <div className="flex items-center gap-2" data-id="element-278">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-279" />
                    <span className="text-gray-200 text-sm" data-id="element-280">
                      +1000 planos industriales
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-281">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-282" />
                    <span className="text-gray-200 text-sm" data-id="element-283">
                      Herrería Artística
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-284">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-285" />
                    <span className="text-gray-200 text-sm" data-id="element-286">
                      Carpintería que Vende
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-287">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-288" />
                    <span className="text-gray-200 text-sm" data-id="element-289">
                      Tornería desde Cero
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-290">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-291" />
                    <span className="text-gray-200 text-sm" data-id="element-292">
                      Presupuesto + Ventas
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-293">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-294" />
                    <span className="text-gray-200 text-sm" data-id="element-295">
                      Soldadura desde Cero
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-296">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-297" />
                    <span className="text-gray-200 text-sm" data-id="element-298">
                      Planos Premium
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-299">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-300" />
                    <span className="text-gray-200 text-sm" data-id="element-301">
                      Acceso inmediato
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-302">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-303" />
                    <span className="text-gray-200 text-sm" data-id="element-304">
                      Descarga digital
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-305">
                    <CheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-306" />
                    <span className="text-gray-200 text-sm" data-id="element-307">
                      Acceso de por vida
                    </span>
                  </div>

                  {/* Extras exclusivos */}
                  <div className="border-t border-gray-600 pt-3 mt-3" data-id="element-308">
                    <p className="text-amber-400 text-sm font-bold mb-2" data-id="element-309">
                      + Extras exclusivos:
                    </p>
                    <div className="flex items-center gap-2" data-id="element-310">
                      <StarIcon className="w-4 h-4 text-amber-400 fill-amber-400 flex-shrink-0" data-id="element-311" />
                      <span className="text-amber-200 text-sm font-semibold" data-id="element-312">
                        15 Trabajos Más Vendidos en Mercado Libre
                      </span>
                    </div>
                    <div className="flex items-center gap-2 mt-1" data-id="element-313">
                      <StarIcon className="w-4 h-4 text-amber-400 fill-amber-400 flex-shrink-0" data-id="element-314" />
                      <span className="text-amber-200 text-sm font-semibold" data-id="element-315">
                        Portones Automáticos – Planos completos
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Social proof */}
          <p className="text-center text-amber-400 text-sm font-semibold mb-8" data-id="element-316">
            🔥 El 80% de nuestros clientes elige el Pack Completo.
            <br data-id="element-317" />
            <span className="text-gray-400 font-normal italic" data-id="element-318">
              Es el que más valor tiene por su precio.
            </span>
          </p>

          {/* CTA Button */}
          <CTAButton href={checkoutUrl} className="max-w-lg mx-auto" data-id="element-319">
            🛒 COMPRAR AHORA
          </CTAButton>
          <p className="text-center text-gray-500 text-xs mt-3" data-id="element-320">
            Descarga inmediata · Garantía de 7 días
          </p>

          <p className="text-center text-green-400 font-semibold text-sm mt-4" data-id="element-321">
            💳 Pagalo en tu moneda local
          </p>

          <div className="mt-3 flex items-center justify-center gap-2 text-gray-500 text-xs" data-id="element-322">
            <span data-id="element-323">🔒</span>
            <span data-id="element-324">Pago seguro · Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}